import { z } from "zod";
import { idSchema, isoDateTimeSchema, moneySchema, quantitySchema } from "../primitives.js";

export const createDealInput = z.object({
  skuId: idSchema.nullish(),
  title: z.string().min(1).max(140),
  description: z.string().max(2000).nullish(),
  qtyAvailable: quantitySchema,
  unitPrice: moneySchema,
  expiresAt: isoDateTimeSchema,
});

export const claimInput = z.object({ qty: quantitySchema });

export type CreateDealInput = z.infer<typeof createDealInput>;
export type ClaimInput = z.infer<typeof claimInput>;
